import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PrimaryButton } from "@/components/site/Primitives";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function CheckoutDialog({ open, onOpenChange, onConfirm, submitting, title = "Almost there" }) {
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (open) {
      setName(user?.name || "");
      setEmail(user?.email || "");
    }
  }, [open, user]);

  const submit = (e) => {
    e.preventDefault();
    const n = name.trim();
    const em = email.trim();
    if (!n) { toast.error("Please enter your name."); return; }
    if (!EMAIL_RE.test(em)) { toast.error("Please enter a valid email address."); return; }
    onConfirm(n, em);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-brand-cream border-brand-linen sm:max-w-md" data-testid="checkout-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-brand-charcoal">{title}</DialogTitle>
        </DialogHeader>
        <p className="font-body text-brand-body text-sm -mt-1 mb-1">Tell us where to send your books and receipt.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block font-sans text-[0.66rem] uppercase tracking-[0.12em] text-brand-muted mb-1.5">Your name</label>
            <input
              data-testid="checkout-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              className="w-full border border-brand-linen bg-white px-4 py-2.5 font-body text-brand-charcoal focus:border-brand-gold outline-none transition-colors"
              placeholder="Jane Cottager"
            />
          </div>
          <div>
            <label className="block font-sans text-[0.66rem] uppercase tracking-[0.12em] text-brand-muted mb-1.5">Email address</label>
            <input
              data-testid="checkout-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-brand-linen bg-white px-4 py-2.5 font-body text-brand-charcoal focus:border-brand-gold outline-none transition-colors"
              placeholder="you@example.com"
            />
          </div>
          <div className="pt-1 flex justify-center">
            <PrimaryButton type="submit" testid="checkout-continue" disabled={submitting}>
              {submitting ? "Opening checkout…" : "Continue to secure payment"}
            </PrimaryButton>
          </div>
          <p className="font-sans text-[0.62rem] uppercase tracking-[0.12em] text-brand-muted text-center">
            Instant delivery · Secure Stripe checkout
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
